// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4e72ba8a","239":"05d1037d","455":"a8f08bfa"}[chunkId] + ".chunk.js";
};